import { render, staticRenderFns } from "./Carousel1Slide.vue?vue&type=template&id=7a164ee2&scoped=true&"
import script from "./Carousel1Slide.vue?vue&type=script&lang=js&"
export * from "./Carousel1Slide.vue?vue&type=script&lang=js&"
import style0 from "./Carousel1Slide.vue?vue&type=style&index=0&id=7a164ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a164ee2",
  null
  
)

export default component.exports